import { useContext } from "react";
import { DashboardDataContext } from "./DashboardContext";

const useDashboardContext = () => {
    const data = useContext(DashboardDataContext);
    return data;
}

export default useDashboardContext;